import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { StyledButton } from './styles';

export const Button = ({
  className,
  backgroundColor,
  borderColor,
  children,
  disabled,
  faded,
  fetching,
  onClick,
  size,
  textColor,
  variant,
  forwardedRef,
  ...props
}) => {
  const buttonClick = (e) => {
    if (e) {
      e.persist();
      e.preventDefault();
    }
    return !disabled && !fetching && onClick(e);
  };

  return (
    <StyledButton
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      className={className}
      disabled={disabled}
      faded={faded}
      fetching={fetching}
      onClick={buttonClick}
      ref={forwardedRef}
      size={size}
      textColor={textColor}
      variant={variant}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  backgroundColor: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  borderColor: PropTypes.oneOf(['', 'secondary', 'tertiary']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  faded: PropTypes.bool,
  fetching: PropTypes.bool,
  forwardedRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md']),
  targetRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  textColor: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  variant: PropTypes.oneOf([
    '',
    'ghost',
    'empty',
    'text',
    'iconAndText',
    'stroke',
    'primary',
  ]),
};

Button.defaultProps = {
  backgroundColor: 'primary',
  borderColor: '',
  className: '',
  disabled: false,
  faded: false,
  fetching: false,
  forwardedRef: undefined,
  onClick: () => {},
  size: 'md',
  targetRef: undefined,
  textColor: 'tertiary',
  variant: '',
};

export const ForwardedButton = forwardRef((props, ref) => (
  <Button forwardedRef={ref} {...props} />
));
